import React from 'react';
import './BuiltForSection.css';

const BuiltForSection = () => {
  const studentBenefits = [
    'Career exploration across all streams',
    'Entrance exam planning and tracking',
    'College comparison and selection',
    'Application timeline guidance'
  ];

  const institutionBenefits = [
    'White-labelled platform with your branding',
    'No operational burden on staff',
    'Enhance student satisfaction and outcomes',
    'Quick setup with ongoing support'
  ];

  return (
    <section className="section built-for-section">
      <div className="container">
        <span className="built-for-label">WHO WE SERVE</span>
        <h2 className="section-title built-for-title">
          <span className="title-navy">Built for </span>
          <span className="title-orange">Students & Institutions</span>
        </h2>
        <p className="section-subtitle built-for-subtitle">Whether you're planning your future or guiding the next generation.</p>

        <div className="audience-grid">
          <div className="audience-card students-card">
            <div className="audience-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                <path d="M6 12v5c3 3 9 3 12 0v-5" />
              </svg>
            </div>
            <h3 className="audience-title">For Students</h3>
            <p className="audience-description">
              Class 11 & 12 students seeking clarity on courses, careers, entrance exams, and college applications.
            </p>
            <ul className="audience-benefits">
              {studentBenefits.map((benefit, index) => (
                <li key={index} className="benefit-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="benefit-check">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="audience-card institutions-card">
            <div className="audience-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>
            </div>
            <h3 className="audience-title">For Institutions</h3>
            <p className="audience-description">
              Schools and colleges offering comprehensive career guidance under their own brand.
            </p>
            <ul className="audience-benefits">
              {institutionBenefits.map((benefit, index) => (
                <li key={index} className="benefit-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="benefit-check">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuiltForSection;
